'use strict';

exports.__esModule = true;
var URGENT_APPOINTMENT_CHANGE = exports.URGENT_APPOINTMENT_CHANGE = 'INFO_MODALS:URGENT_APPOINTMENT_CHANGE';
var ACCESS_PHYSIO_CHANGE = exports.ACCESS_PHYSIO_CHANGE = 'INFO_MODALS:ACCESS_PHYSIO_CHANGE';
var GET_VGP_APP_CHANGE = exports.GET_VGP_APP_CHANGE = 'INFO_MODALS:GET_VGP_APP_CHANGE';
var HEALTH_INFO_CHANGE = exports.HEALTH_INFO_CHANGE = 'INFO_MODALS:HEALTH_INFO_CHANGE';

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_infoModalsActionsType', {
  value: require('react').PropTypes.shape({
    changeUrgentAppointmentModal: require('react').PropTypes.func.isRequired,
    changeAccessPhysioModal: require('react').PropTypes.func.isRequired,
    changeGetVGPAppModal: require('react').PropTypes.func.isRequired,
    changeHealthInfoModal: require('react').PropTypes.func.isRequired
  })
});
var infoModalsActions = exports.infoModalsActions = {
  changeUrgentAppointmentModal: function changeUrgentAppointmentModal(newState) {
    return {
      type: URGENT_APPOINTMENT_CHANGE,
      payload: {
        urgentAppointmentModal: newState
      }
    };
  },
  changeAccessPhysioModal: function changeAccessPhysioModal(newState) {
    return {
      type: ACCESS_PHYSIO_CHANGE,
      payload: {
        accessPhysioModal: newState
      }
    };
  },
  changeGetVGPAppModal: function changeGetVGPAppModal(newState) {
    return {
      type: GET_VGP_APP_CHANGE,
      payload: {
        getVGPAppModal: newState
      }
    };
  },
  changeHealthInfoModal: function changeHealthInfoModal(newState) {
    return {
      type: HEALTH_INFO_CHANGE,
      payload: {
        healthInfoModal: newState
      }
    };
  }
};


// WEBPACK FOOTER //
// ./components/home-page/lib/actions/info-modals.js